import {
  EPICS_DEFINITIONS as EPICS,
  EPICS_TASK_VIEWS as TASKS,
  EPICS_TOAST_PROPS as TOAST,
} from 'volto-epics-addon/constants';

export const EPIC_LIVE_STREAM = 'live-stream';
EPICS[EPIC_LIVE_STREAM] = EPIC_LIVE_STREAM;

export const TASK_LIVE_INFO_PROMPT = 'live-info-prompt';
TASKS[TASK_LIVE_INFO_PROMPT] = '/live-info-prompt';
TOAST[TASK_LIVE_INFO_PROMPT] = {
  title: 'Live was not started.',
  showCancel: true,
};

export const TASK_LIVE_JOBS_VIEW = 'live-jobs-view';
TASKS[TASK_LIVE_JOBS_VIEW] = '/wait-for-live-jobs';
TOAST[TASK_LIVE_JOBS_VIEW] = {
  title: 'Waiting for jobs...',
  showCancel: true,
};

export const AGREEMENT_PATH = '/agreement';

// Absolute URLs: the not-found page is shown on someone else's site.
export const EMBED_FAQ_URLS = {
  fi: 'https://moniviestin.jyu.fi/fi/ohjeet/usein-kysyttya',
  en: 'https://moniviestin.jyu.fi/en/info/faq',
};
